export default __webpack_public_path__ + "static/media/469.09433820.png";